/**
 * 稳定 ID 生成工具。
 *
 * 优先使用 `crypto.randomUUID()`；在缺少 Web Crypto 的环境（老浏览器、部分
 * Node 测试环境）退化为时间戳 + 随机数的实现，保证仍然得到唯一字符串。
 */

function randomSuffix(): string {
  const cryptoObj = globalThis.crypto as Crypto | undefined;
  if (cryptoObj && typeof cryptoObj.getRandomValues === 'function') {
    const bytes = new Uint8Array(8);
    cryptoObj.getRandomValues(bytes);
    return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  }
  return Math.random().toString(16).slice(2).padEnd(16, '0').slice(0, 16);
}

/** 生成一个新的全局唯一 ID。 */
export function newId(): string {
  const cryptoObj = globalThis.crypto as Crypto | undefined;
  if (cryptoObj && typeof cryptoObj.randomUUID === 'function') {
    return cryptoObj.randomUUID();
  }
  return `${Date.now().toString(36)}-${randomSuffix()}`;
}